import React from "react";

export function SiteFooter({ logoSrc }) {
  return (
    <footer className="border-t border-accent bg-primary px-6 py-16 text-white md:px-10">
      <div className="mx-auto flex max-w-[1200px] flex-col gap-12 md:flex-row md:justify-between">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:gap-10">
          {logoSrc && (
            <img
              src={logoSrc}
              alt="KR Aesthetics"
              className="h-20 w-20 rounded-none object-cover"
            />
          )}
          <div>
            <p className="font-heading text-xl font-semibold">Dr. Karim Rafla</p>
            <p className="mt-2 max-w-md font-body text-sm font-light text-white/85">
              Consultant Grade A Plastic &amp; Aesthetic Surgeon. Member of the
              Royal College of Surgeons of England. Founder of KR Aesthetics.
            </p>
          </div>
        </div>
        <div>
          <p className="font-body text-xs font-medium uppercase tracking-[2px] text-accent">
            Contact
          </p>
          <p className="mt-3 font-body text-sm font-light">
            <a href="tel:+201222144609" className="hover:text-accent">
              +20 122 214 4609
            </a>
          </p>
          <p className="mt-1 font-body text-sm font-light">
            <a href="tel:+201206033333" className="hover:text-accent">
              +20 120 603 3333
            </a>
          </p>
          <p className="mt-1 font-body text-sm font-light">
            <a
              href="mailto:contact.drkarimrafla@gmail.com"
              className="hover:text-accent"
            >
              contact.drkarimrafla@gmail.com
            </a>
          </p>
          <p className="mt-4 font-body text-xs tracking-[1.5px] text-white/70">
            Heliopolis · Zamalek · Sheikh Zayed · New Cairo
          </p>
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-[1200px] border-t border-white/20 pt-8 text-center font-body text-[13px] tracking-[1.5px] text-white/60 md:text-left">
        &copy; {new Date().getFullYear()} Dr. Karim Rafla — KR Aesthetics. All
        rights reserved.
      </div>
    </footer>
  );
}
